<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">{{ props.item.qhseName }}</td>
          <td style="text-align: left">{{ props.item.prevUnits }}</td>
          <td style="text-align: left">{{ props.item.units }}</td>
          <td style="text-align: left">{{ props.item.prevUnits + props.item.units }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
    <v-container fluid>
      <v-textarea auto-grow outlined clear-icon="mdi-close-circle" readonly>
        <template v-slot:label>{{ $t('vessel.additionalQHSE') }}</template>
      </v-textarea>
    </v-container>
  </v-container>
</template>


<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "qhse-act",
    data() {
      return {
        headers: [
        { text: this.$t('vessel.act'), align: 'start', value: 'act' },
        { text: this.$t('vessel.prevunits'), value: 'prevUnits', width: '150px' },
        { text: this.$t('vessel.currunits'), value: 'currunits', width: '150px' },
        { text: this.$t('vessel.totunits'), value: 'totunits', width: '150px' }
        ],
        currentMainDprId: null,
        currentPVId: null,
      };
    },
    computed: {
      ...mapGetters([
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
        "mv_vesselQhse/getQhses",
      ]),
      items() {
        return this["mv_vesselQhse/getQhses"];
      }
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this.refreshQhses();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_vesselQhse/fetchQhsesByDprId"
      ]),

      refreshQhses() {
        this["mv_vesselQhse/fetchQhsesByDprId"](this.currentMainDprId);
      },
    }
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
